import { Outlet } from "react-router-dom";

const Unidades = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Unidades;
